"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSWarrantyComponent = void 0;
const warranty_service_1 = require("../services/warranty.service");
const generic_content_service_1 = require("../services/generic.content.service");
class CSWarrantyComponent {
    constructor(warrantyService, genericContentService) {
        this.warrantyService = warrantyService;
        this.genericContentService = genericContentService;
        this.warrantyInfo();
    }
    navigate(mobileNumber, manufacturerName, deviceDisplayName) {
        location.href = '/online-warranty/online-warranty-process/?mdnSelected=true&displayName=' +
            manufacturerName + (' ').replace(/ /g, '+') + deviceDisplayName.replace(/ /g, '+') + '&deviceName=' +
            manufacturerName + '&mobileNumber=' + mobileNumber + '#/issue-category';
    }
    warrantyInfo() {
        this.loader = true;
        this.warrantyService.getWarrantyDetails()
            .subscribe((res) => {
            if (res == null) {
                this.noWarrantyInformation();
            }
            else {
                this.warrantyDetails = res;
                this.loader = false;
            }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    noWarrantyInformation() {
        this.genericContentService.getGenericContent('genericContentNoExtendedWarranty').subscribe((data) => {
            this.noExtendedWarrantyInformation = data.contentText;
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
}
exports.CSWarrantyComponent = CSWarrantyComponent;
//# sourceMappingURL=warranty.component.js.map